// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__W7pdn","choiceBoxes":"toolbarselects_choiceBoxes__3RiJ6","simpleField":"toolbarselects_simpleField__agJZG"};